const CAROUSEL_ITEMS = [
  {
    tag: '热门专题',
    title: '暑期档必看 · 年度高分电影精选',
    desc: '盘点今年口碑炸裂的高分佳作，从悬疑烧脑到温情治愈，每一部都值得反复品味。天美影视高清片源，带你沉浸式体验大银幕魅力。',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20warm%20golden%20atmosphere%20with%20abstract%20film%20elements%2C%20soft%20theater%20lighting%2C%20elegant%20movie%20premiere%20vibe%2C%20rich%20red%20and%20amber%20tones%2C%20luxurious%20cinema%20texture%2C%20no%20text%20no%20people%2C%20clean%20artistic%20composition&width=800&height=500&seq=carousel-01&orientation=landscape',
    alt: '天美影视暑期档高分电影专题',
  },
  {
    tag: '热播剧集',
    title: '国产剧巅峰 · 近三年豆瓣8.5+神作合集',
    desc: '精选近三年豆瓣评分8.5以上的国产口碑剧，从古装权谋到都市情感，天美影视流畅不卡顿，陪你一口气刷完全集。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20dramatic%20lighting%20with%20deep%20crimson%20and%20amber%20gradients%2C%20abstract%20streaming%20platform%20visual%2C%20cinematic%20texture%20with%20soft%20bokeh%2C%20elegant%20film%20industry%20atmosphere%2C%20no%20text%20no%20people%2C%20clean%20artistic%20composition&width=800&height=500&seq=carousel-02&orientation=landscape',
    alt: '天美影视国产剧高分神作合集',
  },
  {
    tag: '经典重温',
    title: '永不褪色的经典 · 华语电影百年佳片巡礼',
    desc: '从第五代导演到新锐力量，重温那些定义了华语电影的经典之作。天美影视高清修复片源，让经典焕发新生，画质细腻如初见。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20cinema%20atmosphere%20with%20warm%20sepia%20and%20golden%20tones%2C%20classic%20film%20projector%20light%20rays%2C%20nostalgic%20movie%20theater%20vibe%2C%20elegant%20old%20Hollywood%20style%2C%20rich%20texture%2C%20no%20text%20no%20people%2C%20clean%20artistic%20composition&width=800&height=500&seq=carousel-03&orientation=landscape',
    alt: '天美影视华语电影经典佳片巡礼',
  },
  {
    tag: '新片速递',
    title: '2026年最值得期待的院线新片前瞻',
    desc: '抢先了解今年即将上映的重磅大片，从国产巨制到海外引进，天美影视持续更新最新高清片源，让你不错过任何一部好片。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20futuristic%20cinema%20visual%20with%20deep%20red%20and%20golden%20neon%20accents%2C%20sleek%20streaming%20platform%20aesthetic%2C%20dramatic%20lighting%20with%20lens%20flares%2C%20premium%20movie%20experience%20atmosphere%2C%20no%20text%20no%20people%2C%20clean%20artistic%20composition&width=800&height=500&seq=carousel-04&orientation=landscape',
    alt: '天美影视2026院线新片前瞻',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">精选推荐</h2>
          <p className="mt-2 text-sm text-foreground-600">每日精选热门影视专题，发现你的下一部好片</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {CAROUSEL_ITEMS.map((item, idx) => (
            <div
              key={idx}
              className="group relative rounded-xl overflow-hidden bg-background-100 border border-background-200/70 hover:border-primary-300/40 transition-all duration-300 cursor-pointer"
            >
              <div className="aspect-[16/10] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.alt}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/70 via-transparent to-transparent"></div>
              </div>
              <div className="absolute bottom-0 left-0 right-0 p-5 md:p-6">
                <span className="inline-block px-3 py-1 bg-accent-500 text-background-950 text-xs font-semibold rounded-full mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="font-heading text-lg md:text-xl text-background-50 mb-1">{item.title}</h3>
                <p className="text-xs md:text-sm text-foreground-300 line-clamp-2 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}